import {
  Datagrid,
  DateField,
  EditButton,
  List,
  NumberField,
  TextField,
} from "react-admin";

export function FaqList() {
  return (
    <List>
      <Datagrid>
        <TextField source="id" />
        <TextField source="question" />
        <NumberField source="serialNumber" />
        <DateField source="createdDate" />
        <DateField source="updatedDate" />
        <EditButton />
      </Datagrid>
    </List>
  );
}
